import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService, TransformableElement } from 'ng-devui';
import {
  AlertDialogComponent,
  AlertDialogType,
} from 'src/app/modules/shared/components/alert-dialog/alert-dialog.component';
import {
  FilePreviewType,
  FilePreviewTypeListMap,
} from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import { ViewScreenType } from 'src/app/modules/shared/components/file-preview/file-preview.component';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { UploadProgress } from 'src/app/modules/shared/providers/request/upload-progress.type';
import { JgVisualInspReportFileService } from 'src/app/modules/shared/services/jg-visual-insp-report-file.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-insp-report-view-appear',
  templateUrl: './handover-insp-report-view-appear.component.html',
  styleUrls: ['./handover-insp-report-view-appear.component.scss'],
})
export class HandoverInspReportViewAppearComponent {
  ViewScreenType = ViewScreenType;

  FilePreviewTypeListMap = FilePreviewTypeListMap;
  FilePreviewType = FilePreviewType;
  transformableImageElementRef!: TransformableElement;

  environment = environment;

  fileList: string[] = [];

  get withToken() {
    return '?token=' + this.globalService.token;
  }

  height = 0;
  width = 0;
  index = 0;
  uploadProgresses: UploadProgress[] = [];

  pdfZoom = 1;
  pdfPages = 1;
  pdfTotal = 0;

  progress: UploadProgress = {
    progress: 0,
    uploading: false,
    msg: '',
  };

  fileTypes: FilePreviewType[] = [];

  get canWrite(): boolean {
    if (location.href.indexOf('#/open') > -1) {
      const query = window.location.href.split('?')[1] ?? '';
      const params = new URLSearchParams(query);
      return params.get('writeable') === 'true';
    }
    return this.globalService.writeAbleByUrl('/handover/appearance');
  }

  constructor(
    private elementRef: ElementRef,
    private activatedRoute: ActivatedRoute,
    private globalService: GlobalService,
    private modalService: ModalService,
    private jgVisualInspReportFileService: JgVisualInspReportFileService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    window.addEventListener('resize', () => {
      this.resize();
    });
    this.jgVisualInspReportFileService
      .findById(this.activatedRoute.snapshot.params['id'])
      .subscribe((res) => {
        this.elementRef.nativeElement.parentElement.style.background =
          'transparent';
        if (res) {
          this.fileList = [res.fileId!];
          this.onFileListChange();
          this.resize();
          this.changePreview(0);
        } else {
          window.close();
        }
      });
  }

  onPageLoad(event: any) {
    this.pdfTotal = event.source.pdfDocument._pdfInfo.numPages;
  }

  prePage() {
    if (this.pdfPages > 1) {
      this.pdfPages--;
    }
  }

  nextPage() {
    if (this.pdfPages < this.pdfTotal) {
      this.pdfPages++;
    }
  }

  originSize() {
    if (this.fileTypes[this.index] === FilePreviewType.Image) {
      this.transformableImageElementRef.setOriginalScale();
    }
    if (this.fileTypes[this.index] === FilePreviewType.PDF) {
      this.pdfZoom = 1;
    }
  }

  zoomIn() {
    if (this.fileTypes[this.index] === FilePreviewType.Image) {
      this.transformableImageElementRef.zoomIn();
    }
    if (this.fileTypes[this.index] === FilePreviewType.PDF) {
      this.pdfZoom += 0.1;
      if (this.pdfZoom > 2) {
        this.pdfZoom = 2;
      }
    }
  }

  zoomOut() {
    if (this.fileTypes[this.index] === FilePreviewType.Image) {
      this.transformableImageElementRef.zoomOut();
    }
    if (this.fileTypes[this.index] === FilePreviewType.PDF) {
      this.pdfZoom -= 0.1;
      if (this.pdfZoom < 0.5) {
        this.pdfZoom = 0.5;
      }
    }
  }

  download() {
    const downloadLink = document.createElement('a');
    const url = this.fileList[this.index];
    downloadLink.href = environment.fileHost + url + this.withToken;
    const fileName = url.split('/').pop();
    downloadLink.target = '_blank';
    downloadLink.download = fileName!;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  resize() {
    this.height = document.body.clientHeight;
    this.width = document.body.clientWidth;
  }

  remove() {
    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除文件',
        content: '确认删除？',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.confirm,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          results.modalInstance.hide();
          this.jgVisualInspReportFileService
            .remove(this.activatedRoute.snapshot.params['id'])
            .subscribe((res) => {
              window.close();
            });
        },
      },
    });
  }

  onFileListChange() {
    const fileTypes: FilePreviewType[] = [];
    for (const i of this.fileList) {
      const extName = i.split('.').pop();
      switch (extName) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'bmp':
        case 'webp':
        case 'svg':
          fileTypes.push(FilePreviewType.Image);
          break;
        case 'pdf':
          fileTypes.push(FilePreviewType.PDF);
          break;
      }
    }
    this.fileTypes = fileTypes;
  }

  changePreview(index: number) {
    this.index = index;
    this.pdfZoom = 1;
    this.pdfPages = 1;
    if (this.transformableImageElementRef) {
      this.transformableImageElementRef.removeElementListener();
    }
    setTimeout(() => {
      this.resize();
      const e = this.getImgElement();
      if (e) {
        let scale = 1;
        if (e.clientHeight > e.clientWidth) {
          scale = this.height / e.clientHeight;
        } else {
          scale = this.width / e.clientWidth;
        }
        if (scale > 1) {
          scale = 1;
        }
        this.transformableImageElementRef = new TransformableElement(e, {
          zoom: scale,
        });
      }
    }, 200);
  }

  private getImgElement(): HTMLElement {
    return this.elementRef.nativeElement.querySelector('img.preview');
  }
}
